import { useQuery } from '@tanstack/react-query'
import { SmartInsight } from 'src/charts/SmartInsightsAIRecommendations'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'

interface SmartInsightsData {
  hasInsights: boolean
  insights: SmartInsight[]
}

interface SmartInsightsResponse {
  data: SmartInsightsData
}

interface UseGetContentAnalysisSmartInsightsQueryParams {
  fromDate?: string
  id: string
  toDate?: string
}

export const useGetContentAnalysisSmartInsightsQuery = ({
  fromDate,
  id,
  toDate,
}: UseGetContentAnalysisSmartInsightsQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () =>
      ContentAnalysisApiService.getSmartInsights<SmartInsightsResponse>(id, {
        fromDate,
        toDate,
      }),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_SMART_INSIGHTS,
      id,
      fromDate,
      toDate,
    ],
  })
}
